<div class="container-long-running-task-overview">
  <app-header [title]="'Jobs running'" [description]="'Here is a list of all the long-running jobs you have running'"></app-header>

  <!-- List of events -->
  <div class="long-running-task-events-list">
    <ng-container *ngFor="let task of allTasks">
      <app-long-running-task-display [task]="task"></app-long-running-task-display>
    </ng-container>
  </div>
</div>